<template>



  <div class="columns is-centered mt-5">
    <div class="column is-half-tablet">

      <div class="box">
        <form @submit.prevent>
          
          <h1 class="title">Login</h1>

          <b-field label="Email" label-for="email" 
            :type="{'is-danger': errors.email}"
            :message="errors.email || 'For login and crusade management purposes only'">
            <b-input v-model.trim="email" id="email" placeholder="Email" autocomplete="email"></b-input>
          </b-field>

          <b-field label="Password" label-for="password" 
            :type="{'is-danger': errors.password}"
            :message="errors.password || 'At least 6 characters'">
            <b-input type="password" v-model.trim="password" id="password"  autocomplete="new-password"></b-input>
          </b-field>

          <button @click="login()" class="button is-primary">Log In</button>
          <div class="extras mt-3 content is-small">
            <router-link :to="{ name: 'account.passwordreset' }">Forgot Password?</router-link>
            <router-link :to="{ name: 'account.register' }">New User?</router-link>
          </div>

        </form>
        
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: "",
      password: "",
      errors: []
    };
  },
  methods: {
    login() {
      this.$store.dispatch("login", {
        email: this.email,
        password: this.password
      });
    }
  }
};
</script>